import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore,
  Store,
  StoreEnhancer,
} from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { getReducer } from './Reducer';

export const history = createBrowserHistory();

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: Function;
  }
}

const devTools: Function =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware: StoreEnhancer<any> = applyMiddleware(
  routerMiddleware(history),
  thunk,
  promiseMiddleware
);

const getMiddleware = (env: string) => {
  return env === 'production' ? middleware : devTools(middleware);
};

const getStore = (env: string): Store<AnyAction> => {
  return createStore(getReducer(), getMiddleware(env));
};

export { getStore };
